import apiClient from "./client";

export default {
  // Assets
  getAssets: (params) => apiClient.get("/pm/assets", { params }),
  getAsset: (id) => apiClient.get(`/pm/assets/${id}`),
  createAsset: (data) => apiClient.post("/pm/assets", data),
  updateAsset: (id, data) => apiClient.put(`/pm/assets/${id}`, data),
  deleteAsset: (id) => apiClient.delete(`/pm/assets/${id}`),
  // Pre-flight: returns { canDelete, blockers, message } listing anything still
  // linked to the asset (photos, tasks, work orders, …) so the user can be
  // advised to remove it first. Nothing is deleted by this call.
  checkAssetDeletable: (id) => apiClient.get(`/pm/assets/${id}/delete-check`),
  reseedAssetCodes: (assetIds, basePattern) => apiClient.post("/pm/assets/reseed-codes", { assetIds, basePattern }),
  reorderAssets: (items) => apiClient.post("/pm/assets/reorder", { items }),
  exportAssetsToExcel: () => apiClient.post("/pm/assets/export/excel", {}, { responseType: 'blob' }),
  exportAssetsToGeoJson: (params) => apiClient.get("/pm/assets/export/geojson", { params, responseType: 'blob' }),

  // Map
  // Optional params: { locationId } — when set, server returns only the
  // assets in that zone instead of the full customer estate.
  getAssetsMap: (params) => apiClient.get("/pm/assets/map", { params }),
  // Lazy popup details (last review date, etc.) — fetched only when the
  // user opens an asset's popup, so the bulk /map endpoint stays lean.
  getAssetMapDetail: (assetId) => apiClient.get(`/pm/assets/${assetId}/map-detail`),
  // Tiny direct lookup against Setups_PM_AssetType — populates the type
  // filter checkboxes instantly without waiting for the heavy /map endpoint.
  getAssetTypes: () => apiClient.get("/pm/assets/types"),

  // Asset Tasks
  getAssetTasks: (assetId) => apiClient.get(`/pm/assets/${assetId}/task-templates`),
  createAssetTask: (assetId, data) => apiClient.post(`/pm/assets/${assetId}/task-templates`, data),
  updateAssetTask: (assetId, templateId, data) =>
 apiClient.put(`/pm/asset-task-templates/${templateId}`, data),
 deleteAssetTask: (assetId, templateId) =>
 apiClient.delete(`/pm/asset-task-templates/${templateId}`),

  // Cycles (independent)
  getCycles: (params) => apiClient.get("/pm/cycles", { params }),
  getCycle: (id) => apiClient.get(`/pm/cycles/${id}`),
  createCycle: (data) => apiClient.post("/pm/cycles", data),
  updateCycle: (id, data) => apiClient.put(`/pm/cycles/${id}`, data),
  deleteCycle: (id) => apiClient.delete(`/pm/cycles/${id}`),
  clearCycleWorkOrders: (cycleId) => apiClient.delete(`/pm/cycles/${cycleId}/work-orders`),

  // Cycle Tasks
  getCycleTasks: (cycleId) => apiClient.get(`pm/cycles/${cycleId}/tasks`),

  //new
  createCycleTask: (cycleId, data) =>
  apiClient.post(`/pm/cycle-tasks`, { ...data, CycleId: cycleId }),
  deleteCycleTask: (cycleTaskId) => apiClient.delete(`/pm/cycle-tasks/${cycleTaskId}`),
  updateCycleTask: (cycleTaskId, data) => apiClient.put(`/pm/cycle-tasks/${cycleTaskId}`, data),
  generateWorkOrdersForAll: () => apiClient.post(`/pm/cycles/generate-workorders`),
  generateWorkOrdersForCycle: (cycleId) =>
  apiClient.post(`/pm/cycles/${cycleId}/generate-workorders`),

  //Cycle Assets
  createCycleAsset: (data) => apiClient.post("/pm/cycle-assets", data),
  getCycleAssets: (cycleId) => apiClient.get(`/pm/cycles/${cycleId}/assets`),
  deleteCycleAsset: (id) => apiClient.delete(`/pm/cycle-assets/${id}`),

  //Work Orders
  getWorkOrders: () => apiClient.get("/pm/work-orders"),
  getWorkOrder: (id) => apiClient.get(`/pm/work-orders/${id}`),
  createWorkOrder: (data) => apiClient.post("/pm/work-orders", data),
  updateWorkOrder: (id, data) => apiClient.put(`/pm/work-orders/${id}`, data),
  deleteWorkOrder: (id) => apiClient.delete(`/pm/work-orders/${id}`),
  resendWorkOrderEmail: (id) => apiClient.post(`/pm/work-orders/${id}/resend-email`),
  getWorkOrdersForAsset: (assetId) =>  apiClient.get(`/pm/assets/workorders/history?assetId=${assetId}`),
  exportWorkOrdersToExcel: () => apiClient.post("/pm/work-orders/export/excel", {}, { responseType: 'blob' }),

  // Work Order Assets
  getWorkOrderAssets: (workOrderId) => apiClient.get(`/pm/work-orders/${workOrderId}/assets`),
  getWorkOrderAssetsMap: (workOrderId) => apiClient.get(`/pm/work-orders/${workOrderId}/assets/map`),
  createWorkOrderAsset: (data) => apiClient.post("/pm/work-order-assets", data),
  deleteWorkOrderAsset: (id) => apiClient.delete(`/pm/work-order-assets/${id}`),
  getEmployeeLoading: (start, end, hours) =>  apiClient.get(`/pm/employee-loading?start=${start}&end=${end}&hours=${hours}`),

  // Working Calendar
  getWorkingCalendars: () => apiClient.get("/pm/working-calendar"),
  getWorkingCalendar: (id) => apiClient.get(`/pm/working-calendar/${id}`),
  createWorkingCalendar: (data) => apiClient.post("/pm/working-calendar", data),
  updateWorkingCalendar: (id, data) => apiClient.put(`/pm/working-calendar/${id}`, data),
  deleteWorkingCalendar: (id) => apiClient.delete(`/pm/working-calendar/${id}`),

  // Batch Move Work Orders
  batchMoveWorkOrders: (data) => apiClient.post("/pm/work-orders/batch-move", data),
  
  // Cost Analysis
  getCostAnalysis: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return apiClient.get("/pm/work-orders/cost-analysis", { params });
  },

  // Master Cycles
  getMasterCycles: () => apiClient.get("/pm/master-cycles"),
  getMasterCycle: (id) => apiClient.get(`/pm/master-cycles/${id}`),
  createMasterCycle: (data) => apiClient.post("/pm/master-cycles", data),
  updateMasterCycle: (id, data) => apiClient.put(`/pm/master-cycles/${id}`, data),
  deleteMasterCycle: (id) => apiClient.delete(`/pm/master-cycles/${id}`),
  // Clone a master cycle (settings + day buckets + asset assignments) under a
  // new name and a Monday-snapped start date. data = { newName, newStartDate }.
  copyMasterCycle: (id, data) => apiClient.post(`/pm/master-cycles/${id}/copy`, data),

  // Master Cycle Day Buckets
  getMasterCycleDayBuckets: (masterCycleId) => apiClient.get(`/pm/master-cycles/${masterCycleId}/day-buckets`),
  createMasterCycleDayBuckets: (masterCycleId, daysPerCycle) => apiClient.post(`/pm/master-cycles/${masterCycleId}/day-buckets`, daysPerCycle),
  assignAssetsToDayBucket: (dayBucketId, assetIds) => apiClient.post(`/pm/master-cycles/day-buckets/${dayBucketId}/assets`, assetIds),
  removeAssetsFromDayBucket: (dayBucketId, assetIds) => apiClient.delete(`/pm/master-cycles/day-buckets/${dayBucketId}/assets`, { data: assetIds }),
  deleteDayBucket: (dayBucketId) => apiClient.delete(`/pm/master-cycles/day-buckets/${dayBucketId}`),

  // Master Cycle TEST and GO
  validateMasterCycleSchedule: (masterCycleId) => apiClient.post(`/pm/master-cycles/${masterCycleId}/validate`),
  generateMasterCycleCycles: (masterCycleId, request = {}) => {
    // Support both old format (boolean) and new format (object)
    const payload = typeof request === 'boolean' 
      ? { skipValidation: request }
      : { skipValidation: request.skipValidation || false, fromDate: request.fromDate || null };
    return apiClient.post(`/pm/master-cycles/${masterCycleId}/generate`, payload);
  },
  getMasterCycleGenerateProgress: (masterCycleId) => apiClient.get(`/pm/master-cycles/${masterCycleId}/generate-progress`),

};
